import { Component, OnInit, Renderer2, INJECTOR, Inject, ViewChild, ElementRef, NgZone } from '@angular/core';
import {
    faXTwitter,
    faFacebookSquare,
    faYoutube,
    faInstagram,
    faDev,
    faLinkedin,
    faTiktok,
    faWhatsapp,
    faFlickr,
} from '@fortawesome/free-brands-svg-icons';

import {
    faUserPlus,
    faSearch,
    faAngleDown,
    faAngleRight,
    faLock,
    faLanguage,
    faTimes,
    faNewspaper,
    faStar,
    faCertificate,
    faWallet,
    faTableTennis,
    faSignInAlt,
    faCreditCard,
    faIdCard,
    faAward,
    faChevronRight,
    faSync,
} from '@fortawesome/free-solid-svg-icons';

import { NavigationService } from './../navigation.service';
import { TokenService } from 'src/app/core/services/token.service';
import { AuthService } from '../../auth/auth.service';
import { LocalStorage } from 'src/app/core/localstorage';

import { Router } from '@angular/router';
import { LanguageService } from 'src/app/core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, interval, of } from 'rxjs';
import { delay, map, takeUntil } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { UserService } from '../../user/user.service';
import { WINDOW } from 'src/app/core/http/window.providers';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { DuprModalComponent } from '../../dupr/modal-login/dupr-modal.component';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    destroy$: Subject<void> = new Subject<void>();

    currentTime: string;
    /* Controla exibição do box de pesquisa */
    searchOpen: boolean = false;

    /* Retorno de busca da pesquisa */
    searchResults: any;

    /* Instancia do input de pesquisa */
    @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

    public hostName: string;
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];
    loaded: boolean = false;

    /**
     * production
     * Flag para exibição de barra de desenvolvimento
     */
    production: boolean;

    wtnLink?: string;

    icons = {
        /* social */
        facebook: faFacebookSquare,
        twitter: faXTwitter,
        youtube: faYoutube,
        instagram: faInstagram,
        linkedin: faLinkedin,
        tiktok: faTiktok,
        whatsapp: faWhatsapp,
        flickr: faFlickr,

        /* auth */
        user: faSignInAlt,
        documents: faIdCard,
        userPlus: faUserPlus,
        userFiliation: faAward,
        userFinances: faWallet,
        userCertificates: faCertificate,
        games: faTableTennis,
        card: faCreditCard,
        syncOutline: faSync,
        /* search */
        search: faSearch,
        close: faTimes,
        angleDown: faAngleDown,
        angleRight: faAngleRight,
        chevronRight: faChevronRight,
        lock: faLock,
        language: faLanguage,

        news: faNewspaper,
        star: faStar,
        dev: faDev,
    };

    constructor(
        private navigationService: NavigationService,
        private localStorage: LocalStorage,
        public authService: AuthService,
        public userService: UserService,
        public languageService: LanguageService,
        private router: Router,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        @Inject(WINDOW) private window: Window,
        private ngZone: NgZone,
        private toastrService: NbToastrService,
        private translate: TranslateService,
        private nbDialogService: NbDialogService
    ) {
        this.hostName = this.window.location.hostname;
    }

    ngOnInit(): void {
        // Inicializar o token através do domínio utilizado
        // this.tokenService.initializeToken();
        ////console.log('host=' + this.hostName);
        this.getSocial();

        this.userService.currentUser.subscribe(() => {
            this.getWtnLink();
        });
    }

    getWtnLink() {
        this.userService.getWtnLink()?.subscribe((res) => {
            this.wtnLink = res.registers?.link;
        });
    }
    /**
     * logout() - Realiza logout
     */
    logout() {
        this.authService.logout().subscribe((resp) => {
            //console.log(resp);
            this.wtnLink = undefined;
            this.userService.currentUser.next(null);
            this.ngZone.run(() => {
                this.router.navigate(['/home']);
                this.toastrService.success(resp.description, this.translate.instant('ALERT.SUCCESS.TITLE'));
            });
        });
    }

    /**
     * getMenu() - Buscar itens do menu horizontal
     */
    getSocial() {
        this.navigationService.getSocialMenu().subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * changeLang() - Mudar lingua do site
     */
    changeLang(selectedLang) {
        const previous = this.languageService.selectedLanguage.getValue();
        this.languageService.changeLanguage(previous, selectedLang, true);
        // this.translateService.use(selectedLang.key);
    }
    /**
     * search() - Realiza busca no sistema
     * @param event: FormEvent
     * @param keyword: string
     */
    async search(event, keyword: string) {
        event.preventDefault();

        /* Se nada for digitado, não pesquisa */
        if (!keyword) return;

        /* Realiza busca no sistema com a keyword digitada */
        const response = await this.navigationService.search(keyword).toPromise();
        this.searchResults = response.registers;
        //console.log(this.searchResults);
    }

    async openSearch() {
        this.searchOpen = true;
        this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
        this.searchInput.nativeElement.focus();
    }

    async closeSearch() {
        this.searchResults = [];
        await this.delay(200).toPromise();
        this.searchOpen = false;
        this.renderer.removeStyle(this.document.body, 'overflow');
        this.searchInput.nativeElement.value = '';
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.production = response.tokenParameter.production;
        this.currentTime = response.tokenParameter?.currentTime?.split(' ')?.[1];
        this.initCountup();
        this.loaded = true;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }

    delay(ms) {
        return of(1).pipe(delay(ms));
    }

    initCountup() {
        const initialMs = this.timeToMilliseconds(this.currentTime);
        const intervalMs = 1000;

        interval(intervalMs)
            .pipe(
                map((tick) => tick * intervalMs),
                takeUntil(this.destroy$)
            )
            .subscribe((second) => {
                const time = this.msToTime(initialMs + second);
                this.currentTime = time;
            });
    }

    timeToMilliseconds(timeString) {
        const [hours, minutes, seconds] = timeString.split(':').map(Number);
        return (hours * 3600 + minutes * 60 + seconds) * 1000;
    }

    msToTime(duration) {
        let seconds: any = Math.floor((duration / 1000) % 60),
            minutes: any = Math.floor((duration / (1000 * 60)) % 60),
            hours: any = Math.floor((duration / (1000 * 60 * 60)) % 24);

        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        return hours + ':' + minutes + ':' + seconds;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    openDuprModal() {
        this.nbDialogService.open(DuprModalComponent);
    }

    showDuprMenu() {
        return this.localStorage.isPickleball() && !this.localStorage.getUser()?.dupr_external_id;
    }
}
